import React from "react";
import { Text } from "@amzn/stencil-react-components/text";
import "./styles.css";

export const IndicatorBrightness = () => {
  return (
    <div className="indicator">
      <Text className="message">
        <p className="emoji">💡</p>
        <p>Too dark</p>
      </Text>
    </div>
  );
};

export const IndicatorPosition = () => {
  return (
    <div className="indicator">
      <Text className="message">
        <p>Center your position</p>
      </Text>
    </div>
  );
};

export const IndicatorBackground = () => {
  return (
    <div className="indicator">
      <Text className="message">
        <p>Use a blank, white background</p>
      </Text>
    </div>
  );
};

export const IndicatorContrast = () => {
  return (
    <div className="indicator">
      <Text className="message">
        <p>Low contrast</p>
      </Text>
    </div>
  );
};

export const IndicatorNoFace = () => {
  return (
    <div className="indicator">
      <Text className="message">
        <p>No face detected</p>
      </Text>
    </div>
  );
};

export const IndicatorManyFaces = () => {
  return (
    <div className="indicator">
      <Text className="message">
        <p>More than 1 person detected</p>
      </Text>
    </div>
  );
};
